import styled from '@emotion/styled'

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
`
